import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { TopBarBannerComponentStyles } from "./top-bar-banner-component.scss";
import Button from "/components/core/button/button-component";
import PricingModalSignupComponent from "/components/pages/pricing-page/pricing-modal-signup-component/pricing-modal-signup-component";
class TopBarBannerComponent extends PureComponent {
    openSignupModal() {
        this.setState({
            signupModalOpen: true
        });
    }
    closeModalSignupCallback() {
        this.setState({
            signupModalOpen: false
        });
    }
    render() {
        const { signupModalOpen } = this.state;
        const { bannerText } = this.props;
        return /*#__PURE__*/ _jsxs(TopBarBannerComponentStyles, {
            className: "top-bar-banner-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "banner-text",
                    children: bannerText
                }),
                /*#__PURE__*/ _jsx(Button, {
                    className: "banner-signup-button",
                    size: "sm",
                    onClickCallback: this.openSignupModal,
                    children: "Sign up"
                }),
                signupModalOpen && /*#__PURE__*/ _jsx(PricingModalSignupComponent, {
                    closeModalCallback: this.closeModalSignupCallback
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.openSignupModal = this.openSignupModal.bind(this);
        this.closeModalSignupCallback = this.closeModalSignupCallback.bind(this);
        this.state = {
            signupModalOpen: false
        };
    }
}
export { TopBarBannerComponent as default };
TopBarBannerComponent.defaultProps = {
    bannerText: "Black Friday deals waiting inside"
};
